import { useEffect, useState } from "react";
import { useLang } from "../../i18n/LanguageContext";

const SECTIONS = [
  { id: "top", en: "Journey", fr: "Parcours" },
  { id: "intro", en: "Partner", fr: "Partenaire" },
  { id: "supply", en: "Divisions", fr: "Divisions" },
  { id: "products", en: "Products", fr: "Produits" },
  { id: "why", en: "Why Us", fr: "Pourquoi" },
  { id: "wholesale", en: "Wholesale", fr: "En gros" },
  { id: "privatelabel", en: "Private Label", fr: "Marque" },
  { id: "sustainability", en: "Sustainability", fr: "Durabilité" },
  { id: "compliance", en: "Quality", fr: "Qualité" },
  { id: "contact", en: "Contact", fr: "Contact" },
];

export const SectionProgress = () => {
  const { lang } = useLang();
  const [active, setActive] = useState("top");

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => { if (e.isIntersecting) setActive(e.target.id); });
      },
      { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
    );
    SECTIONS.forEach((s) => { const el = document.getElementById(s.id); if (el) obs.observe(el); });
    return () => obs.disconnect();
  }, []);

  return (
    <nav data-testid="section-progress" className="hidden lg:flex fixed right-8 top-1/2 -translate-y-1/2 z-40 flex-col gap-3">
      {SECTIONS.map((s) => {
        const isActive = active === s.id;
        return (
          <a key={s.id} href={`#${s.id}`} data-testid={`progress-${s.id}`} className="group flex items-center justify-end gap-3">
            <span className={`text-xs font-semibold uppercase tracking-wider transition-all duration-300 ${isActive ? "text-[#A9CE8A] opacity-100" : "text-white/60 opacity-0 group-hover:opacity-100"}`}>
              {lang === "fr" ? s.fr : s.en}
            </span>
            <span className={`rounded-full transition-all duration-300 ${isActive ? "w-3 h-3 bg-[#A9CE8A]" : "w-2 h-2 bg-white/40 group-hover:bg-white/70"}`} />
          </a>
        );
      })}
    </nav>
  );
};
